export enum ToastConstant {
  /**
   * The time the notification will stay on the screen before disappearing (in
   * ms).
   */
  Timeout = 5000,
  /** The duration of the transition while opening the notification (in ms). */
  TransitionEnter = 600,
  /** The duration of the transition while closing the notification (in ms). */
  TransitionExit = 100,
}
